import React from 'react';
import Icon from '.';

const DoneIcon = props => (
	<Icon {...props} viewBox="0 0 24 24">
		<circle cx="50%" cy="50%" r="50%" />
		<path d="M0 0h24v24H0z" fill="none" />
		<g transform="scale(0.8) translate(3.5, 3)">
			<path
				fill="#FFFFFF"
				d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
			/>
		</g>
	</Icon>
);

export default DoneIcon;
